var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFindYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 29.5,
    fill: "black",
    fillOpacity: 0.5,
    stroke: "#F2D861",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7026,
    cy: 26.7026,
    r: 10.2026,
    stroke: "#F2D861",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9401 47.6532C44.5259 48.239 45.4756 48.239 46.0614 47.6532C46.6472 47.0674 46.6472 46.1177 46.0614 45.5319L43.9401 47.6532ZM32.8534 36.5665L43.9401 47.6532L46.0614 45.5319L34.9747 34.4452L32.8534 36.5665Z",
    fill: "#F2D861"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindYellow);
export default __webpack_public_path__ + "static/media/find-yellow.fb6de52bfb5cca998e967056070ee529.svg";
export { ForwardRef as ReactComponent };